/**
 * Created by eliorc on 3/8/16.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    var lpUtils = require('utils/lpUtils');

    var _ = require('underscore');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAgent = require('web-agent-assets-js/lpAgent');

    var lpTransferController = function (model) {

        var logger = WebAgentLogger.getLogger('lpTransferController');
        var hasAccountToAccountFeature = lpTag.WebAgent.logicController.hasAccountToAccountFeature();

        function updateTransferDataForChat(object) {
            var error;
            var callbackCounts = 2;
            getAvailableSkills({
                chatId: object.chatId,
                includeWaitTime: lpTag.WebAgent.logicController.isLE2(),
                success: updateProgress,
                error: updateProgress
            });

            lpAgent.agent.getAvailableAgents({
                next: true,
                success: updateProgress,
                error: updateProgress
            });

            if (hasAccountToAccountFeature) {
                callbackCounts++;
                getAvailableRemoteAccounts({
                    chatId: object.chatId,
                    success: updateProgress,
                    error: updateProgress
                });
            }

            function updateProgress(data) {
                if (data && data.error) {
                    error = data.error;
                }

                if (--callbackCounts === 0) {
                    if (object.done && typeof object.done === 'function') {
                        object.done({error: error});
                    }
                }
            }

        }


        // Public Api:
        function getSkillsWaitTime(object) {
            logger.info(object, "getSkillsWaitTime");
            return lpTag.WebAgent.predictiveDialerController.getSkillsWaitTime(object);
        }

        function getAvailableSkills(object) {
            if (!object) {
                logger.error('no options supplied for function.', "getAvailableSkills");
                return;

            }
            logger.info(object, "getAvailableSkills");
            lpAgent.chat.getAvailableSkills({
                chatId: object.chatId,
                success: onResponse,
                error: onResponse
            });

            function onResponse(data) {
                if (data.error) {
                    logger.error(data, "getAvailableSkills:onResponse");
                    logger.graph({name: 'getAvailableSkillsError'});
                    invokeCallback(false);
                } else {
                    logger.info("list of skills for transfer received from the server", "getAvailableSkills:onResponse");
                    var skills = data.skills && data.skills.skill ? data.skills.skill : [];
                    if (object.includeWaitTime) {
                        getSkillsWaitTime({
                            skills: _.map(skills, 'id'),
                            success: function (response) {
                                if (response.data) {
                                    var results = response.data;
                                    // merge the data into the skills.
                                    for (var i = 0; i < skills.length; i++) {
                                        var skill = skills[i];
                                        if (results.hasOwnProperty(skill.id)) {
                                            skill.waitTime = results[skill.id];
                                        }
                                    }
                                }
                                invokeCallback(true, skills);
                            },
                            error: function () {
                                logger.error('cannot get wait time for skills', 'getAvailableSkills');
                                logger.graph({name: 'getAvailableSkillsError'});
                                invokeCallback(true, skills);
                            }
                        });
                    } else {
                        invokeCallback(true, skills);
                    }
                }
                data = null;
            }

            function invokeCallback(isSuccess, skills) {
                model.set("chats." + object.chatId + ".transferChat.availableSkills", skills);
                if (isSuccess) {
                    if (typeof object.success === 'function') {
                        object.success({data: skills});
                    }
                }
                else {
                    if (typeof object.error === 'function') {
                        object.error();
                    }
                }
            }
        }

        function getAvailableRemoteAccounts(object) {
            logger.info(object, "getAvailableRemoteAccounts");
            return lpAgent.chat.getAvailableRemoteAccounts(object);
        }

        function transferChat(object) {
            logger.info(object, "transferChat");
            return lpAgent.chat.transferChat(object);
        }

        function transferChatToRemoteAccount(object) {
            logger.info(object, "transferChatToRemoteAccount");
            return lpAgent.chat.transferChatToRemoteAccount(object);
        }

        function canTransferToSkills(chatId, skillsIds) {
            var intersectionSkills, transferToSameSkill, transferToAllSkills, transferToAllowedSubSkill;
            var chatSkillId = parseInt(model.get("chats." + chatId + ".chatInfo.skillIds"), 10);
            var skill = _.find(model.get("skills.array"), {id: chatSkillId});

            if(skill) {
                skillsIds = lpTag.WebAgent.logicController.toNumberTypedArray(skillsIds);
                skill.skillTransferList = skill.skillTransferList || [];

                transferToSameSkill = skillsIds.indexOf(chatSkillId) >= 0;
                transferToAllSkills = _.isUndefined(skill.canTransfer === "undefined") || (skill.canTransfer === true && skill.skillTransferList.length === 0);
                transferToAllowedSubSkill = skill.canTransfer === true && _.intersection(skill.skillTransferList, skillsIds).length > 0;
            }

            return !skill || transferToSameSkill || transferToAllSkills || transferToAllowedSubSkill;
        }

        // if the agent doesn't have any skills -agentSkills is [{ skillId : "-1" }] otherwise [{ skillId: 123456789, name: "qwerty", ...}]
        // skill sorting - the current conversation skill should be displayed first and the others following alphabetically
        function getAllowedAgentSkillsForTransfer(chatId, agentSkills) {
            var chatSkillId, chatSkill, skillTransferList, agentCurrentSkill;
            agentSkills = lpUtils.cloneObject(agentSkills);
            chatSkillId = parseInt(model.get("chats." + chatId + ".chatInfo.skillIds"), 10);
            chatSkill = model.get("skills.data." + chatSkillId) || { id: -1, canTransfer: true, skillTransferList: [] };
            _.forEach(agentSkills, function (skill) {
                skill.skillDescription = model.get("skills.data." + skill.skillId + ".description");
            });
            agentCurrentSkill = _.find(agentSkills, function (agentSkill) { return agentSkill.skillId == chatSkill.id; });
            skillTransferList = (chatSkill && chatSkill.skillTransferList) || [];

            // non transferable
            if (!chatSkill.canTransfer) {
                return agentCurrentSkill ? [agentCurrentSkill] : [];
            }

            // unassigned or transfer to all
            if (chatSkill.id === -1 || (chatSkill.canTransfer && skillTransferList.length === 0)) {
                return sortSkills(agentSkills);
            }

            // limited transfer - check within skill limitations
            var allowedAgentSkills = getAllowedAgentSkills(agentSkills, skillTransferList);
            if (allowedAgentSkills) {
                return sortSkills(allowedAgentSkills);
            }

            return [];


            function sortSkills(agentValidSkills) {
                agentValidSkills = _.sortBy(agentValidSkills, function (skill) { return skill && skill.skillName && (skill.skillName + '').toLowerCase(); }, ['desc']);
                if (!agentCurrentSkill || (agentValidSkills && agentValidSkills.length) <= 1) { // conv with skillId -1 will return here
                    return agentValidSkills;
                }

                agentCurrentSkill.isCurrentSkill = true;

                agentValidSkills = _.filter(agentValidSkills, function (skill) { return skill.skillId !== agentCurrentSkill.skillId; });
                return [agentCurrentSkill].concat(agentValidSkills);
            }

            function getAllowedAgentSkills(agentSkills, skillTransferList) {
                skillTransferList = skillTransferList || [];
                agentSkills = agentSkills || [];

                var allowedSkillTransferList = _.reduce(skillTransferList, function (acc, skillId) {
                    acc[skillId] = true;
                    return acc;
                }, {});

                var allowedSkills = _.filter(agentSkills, function (agentSkill) {
                    return allowedSkillTransferList[agentSkill.skillId];
                });

                return allowedSkills.concat(agentCurrentSkill || []);
            }
        }

        function getTransferErrorCode (errorString, transferTarget) {
            var errObj = {
                'skill not found': 'noSuchSkill',
                'bad request, update skill failed': 'noSuchSkill',
                'bad request, invalid skill - change skill id to valid long value': 'noSuchSkill',
                'bad request, invalid skill - either change method or skill id are null': 'noSuchSkill',
                'bad request, agent does not exist in conversation': 'agentNotInConversation',
                'bad request, agent does not exist': 'noSuchAgent',
                'participantschange failed. user has no privilege to execute transfer to agent': 'userMissingPrivilleges',
                'consumer not allowed to transfer conversation': 'consumerMissingPrivilleges',
                "can't update participant for closed conversation": 'closedConversation',
                "conversation is close.can't update participant for closed dialog": 'closedDialog',
                'conversation cannot be read from data base': 'dbRead',
                'user from current brand is unauthorized to perform action on requested brand': 'unauthorizedUser',
                'agent not allowed.no assigned agent on conversation': 'noAssignedAgent'
            };
            errObj['feature: messaging.transfer_to_agent is not enabled for brand: ' + model.get('account')] = 'disabledFeature';
            errObj['bad request, agent ' + model.get('account') + '.' + (transferTarget && transferTarget.agentId) + ' does not have skill: ' + (transferTarget && transferTarget.skillId)] = 'agentNoSkill';

            errorString = (errorString + '').toLowerCase();
            if (errObj[errorString]) {
                return errObj[errorString];
            }

            return 'default';
        }

        // Private Api
        function init() {
            if (lpAgent.chat) {
                // Register on chat callbacks
                for (var key in lpAgent.chat) {
                    if (lpAgent.chat.hasOwnProperty(key) && String(key).indexOf('on') === 0) {
                        switch (key) {
                            case    "onTransferChat":
                                lpAgent.chat[key](handleTransferChat);
                                break;
                            case    "onTransferChatToRemoteAccount":
                                lpAgent.chat[key](handleTransferChatToRemoteAccount);
                                break;
                            case    "onAvailableRemoteAccounts":
                                lpAgent.chat[key](handleAvailableRemoteAccounts);
                                break;
                        }
                    }
                }
            } else {
                setTimeout(init, 500);
            }
        }

        function handleTransferChat(data) {
            if (data.error) {
                logger.error(data, "handleTransferChat");
                logger.graph({name: 'transferChatError'});
            } else {
                logger.info(data, "handleTransferChat");
                model.modify("chats." + data.chatId, data);
            }
            data = null;
        }

        function handleTransferChatToRemoteAccount(data) {
            if (data.error) {
                logger.error(data, "handleTransferChatToRemoteAccount");
                logger.graph({name: 'transferChatToRemoteAccountError'});
            } else {
                logger.info(data, "handleTransferChatToRemoteAccount");
                model.modify("chats." + data.chatId, data);
            }
            data = null;
        }


        // TODO: Remove Handler! -> ReqRes Approach!
        function handleAvailableRemoteAccounts(data) {
            if (data.error) {
                logger.error(data, "handleAvailableRemoteAccounts");
                logger.graph({name: 'getAvailableAccountsForTransferError'});
            } else {
                logger.info("list of available accounts for transfer received from the server", "handleAvailableRemoteAccounts");
                var remoteAccountSkills = data.availableRemoteAccounts ? getSkillsFromAvailableRemoteAccounts(data.availableRemoteAccounts) : [];
                model.set("chats." + data.chatId + ".transferChat.availableRemoteAccountSkills", remoteAccountSkills);
            }
            data = null;


            function getSkillsFromAvailableRemoteAccounts(availableRemoteAccounts) {
                var availableRemoteAccountSkills = [];
                for (var i = 0; i < availableRemoteAccounts.length; i++) {
                    var remoteAccount = availableRemoteAccounts[i];
                    for (var j = 0; j < remoteAccount.virtualSkill.length; j++) {
                        var remoteSkill = remoteAccount.virtualSkill[j];
                        remoteSkill.accountId = remoteAccount.accountId;
                        remoteSkill.accountName = remoteAccount.accountName;
                        remoteSkill.allowNotOnlineTransfer = remoteAccount.allowNotOnlineTransfer;
                        availableRemoteAccountSkills.push(remoteSkill);
                    }
                }
                return availableRemoteAccountSkills;
            }
        }

        init();

        return {
            getSkillsWaitTime: getSkillsWaitTime,
            getAvailableSkills: getAvailableSkills,
            getAvailableRemoteAccounts: getAvailableRemoteAccounts,
            transferChat: transferChat,
            transferChatToRemoteAccount: transferChatToRemoteAccount,
            updateTransferDataForChat: updateTransferDataForChat,
            canTransferToSkills: canTransferToSkills,
            getAllowedAgentSkillsForTransfer: getAllowedAgentSkillsForTransfer,
            getTransferErrorCode: getTransferErrorCode
        };

    };

    return lpTransferController;

});
